import { RxSuccess } from "./RxSuccess";

export default RxSuccess;
